export const Config = {
  API_URL: process.env.REACT_APP_API_URL
}
